import { useEffect, useRef } from 'react';

type KeyboardShortcut = { key: string; action: () => void };

export const useKeyboardShortcut = (
  shortcuts: KeyboardShortcut[],
  enabled: boolean
) => {
  const enabledRef = useRef(enabled);
  if (enabledRef.current !== enabled) {
    enabledRef.current = enabled;
  }

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (!enabledRef.current) return;

      shortcuts.forEach((shortcut) => {
        if (e.key === shortcut.key) {
          shortcut.action();
        }
      });
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [shortcuts]);
};
